<template>
  <CartBill
    :totalPrice="totalPrice"
    :immediateDiscount="immediateDiscount"
    :deliveryCharge="deliveryCharge"
    :deliveryChargeBeforeDiscount="deliveryChargeBeforeDiscount"
    :minimumOrderPrice="minimumOrderPrice"
    :isReturnAndExchangeItemInCart="isReturnAndExchangeItemInCart"
    :onImmediateButton="openImmediateModal"
    :onDeliveryChargeButton="onDeliveryChargeButton"
    :isEmptyImmediateDiscount="isEmptyImmediateDiscount"
    :defaultDeliveryCharge="defaultDeliveryCharge"
  />
</template>

<script>
import CartBill from '@/presentationals/v2/components/layouts/templates/CartBill'
import { isProvideImmediateDiscount } from '../../../../../config/featureProvider'

export default {
  name: 'CartBillContainer',
  components: {
    CartBill
  },
  computed: {
    totalPrice() {
      return this.$store.getters['cart/totalPrice']
    },
    immediateDiscount() {
      const { appVersion, isAndroid } = this.$store.getters
      if (!isProvideImmediateDiscount({ appVersion, isAndroid })) return 0

      const nowPrice = this.$store.getters['cart/totalPrice']
      const nowDiscount = this.$store.getters['cart/nowCartDiscount'](nowPrice)

      if (!nowDiscount) return 0

      return nowDiscount.discountAmount
    },
    deliveryCharge() {
      const nowPrice = this.$store.getters['cart/totalPrice']
      const nowDeliveryCharge = this.$store.getters['cart/nowCartDeliveryCharge'](nowPrice)

      if (!nowDeliveryCharge) return 0

      return this.defaultDeliveryCharge - nowDeliveryCharge.discountDeliveryCharge
    },
    deliveryChargeBeforeDiscount() {
      const nowPrice = this.$store.getters['cart/totalPrice']
      const nowDeliveryCharge = this.$store.getters['cart/nowCartDeliveryCharge'](nowPrice)

      if (!nowDeliveryCharge) return 0

      return nowDeliveryCharge.deliveryChargeBeforeDiscount
    },
    defaultDeliveryCharge() {
      const defaultDeliveryCharge = this.$store.getters['cart/defaultDeliveryCharge']
      return defaultDeliveryCharge
    },
    minimumOrderPrice() {
      return this.$store.getters['cart/minimumOrderPrice']
    },
    isReturnAndExchangeItemInCart() {
      return this.$store.getters['cart/isReturnAndExchangeItemInCart']
    },
    isEmptyImmediateDiscount() {
      return this.$store.getters['cart/isEmptyImmediateDiscount']
    }
  },
  methods: {
    openImmediateModal() {
      this.$store.dispatch('modal/open', {
        type: 'ImmediateDiscount',
        message: '즉시할인',
        params: { discounts: this.$store.getters['cart/cartDiscounts'] },
        onOK: async () => {
          this.$store.dispatch('modal/close')
        },
        onCancel: async () => {}
      })
    },
    onDeliveryChargeButton() {
      this.$store.dispatch('modal/open', {
        type: 'DeliveryCharge',
        message: '배달팁',
        params: {
          defaultDeliveryCharge: this.defaultDeliveryCharge,
          deliveryCharges: this.$store.getters['cart/cartReverseDeliveryCharges']
        },
        onOK: async () => {
          this.$store.dispatch('modal/close')
        },
        onCancel: async () => {}
      })
    }
  }
}
</script>
